import { Copy } from 'lucide-react';
import toast from 'react-hot-toast';

type Props = {
  value?: string | null;
  label: string;
  testId: string;
};

export default function CopyableValue({ value, label, testId }: Props) {
  async function copy() {
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      toast.success(`${label} copied`);
    } catch {
      toast.error(`Unable to copy ${label.toLowerCase()}. Please select and copy it manually.`);
    }
  }

  return (
    <span className="copyable-value">
      <span className="copyable-value-text" data-testid={`text-${testId}`}>{value || '—'}</span>
      {value && (
        <button
          type="button"
          className="copy-value-button"
          aria-label={`Copy ${label.toLowerCase()}`}
          title={`Copy ${label.toLowerCase()}`}
          data-testid={`copy-${testId}`}
          onClick={copy}
        >
          <Copy size={14} aria-hidden="true" />
        </button>
      )}
    </span>
  );
}
